import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintEdi.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintEdi_edi_get_completed_shipmentsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { project_lookups?: string[], project_ids?: number[], days?: number, shipment_type?: number, transaction_type?: string, has_order_transmissions?: boolean, in_transmission_type?: string, out_transmission_type?: string, integration_id?: string }): Promise<{ orders?: { transaction_id?: string, DatexOrderInfo?: $frontendTypes.FootprintEdi.DatexOrderInfo }[], messages?: any[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

